import { MembershipsDirectMessagesApiClient } from '@fourthwall/services/dist/MembershipsDirectMessagesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateDirectMessagesSettingsMutation = createMutationHook(
  MembershipsDirectMessagesApiClient.updateDirectMessagesSettings,
  {
    mutationKey: ['updateDirectMessagesSettings'],
  },
)
